export default "### We own all our cars\n\nWe’re no marketplace – we own all of our cars and can vouch for every one of them.\n";